import { connect } from "react-redux";

import Component from "./Component";
import { DateTime as Luxon, Interval } from "luxon";
import { noop } from "lodash-es";
import { isLoggedIn } from "domain/Auth/selectors";

import {
    getItemById,
    getIsParticipateItem,
    getUserReserveOrderItem,
    getGamePaymentMethodItem,
    getIsPaySuccessItem,
    getIsPayStatusItem,
    getGameLinkFromList,
} from "domain/GamesSearch/selectors";

import {
    getGameById,
    getGameLink,
    getGamePaymentMethod,
    getIsParticipate,
    getIsPayStatus,
    getIsPaySuccess,
    getUserReserveOrder,
} from "domain/Game/selectors";
import { updateGameData as updateGameDataForPage } from "domain/Game/actions";
import {
    dropCard,
    updateGameData as updateGameDataForList,
} from "domain/GamesSearch/actions";
import { getProfile, getUserId, getUserAge } from "domain/User/selectors";
import { trackPlayerJoin, trackPlayerLeft } from "domain/Analytics/actions";
import { getGameTypeById } from "domain/Directories/selectors";

const mapStateToProps = (state, { listItem, id, inProgress, onError }) => {
    const gameData = listItem ? getItemById(state, id) : getGameById(state, id);
    const { starts_at, duration } = gameData;

    const startDateTime = Luxon.fromSQL(starts_at);
    const gameInterval = Interval.fromDateTimes(
        startDateTime,
        startDateTime.plus({ minutes: duration })
    );
    const now = Luxon.local();

    const userId = getUserId(state);
    const userAge = getUserAge(state);

    return {
        ...gameData,
        userId,
        gameType: getGameTypeById(state, gameData.type_id),
        gameLink: listItem
            ? getGameLinkFromList({ state, gameId: id })
            : getGameLink({ state, gameId: id }),
        is_participate: listItem
            ? getIsParticipateItem(state, id, userId)
            : getIsParticipate(state, id, userId),
        myReserveOrder: listItem
            ? getUserReserveOrderItem(state, id, userId)
            : getUserReserveOrder(state, id, userId),
        isLoggedIn: isLoggedIn(state),
        inProgress:
            inProgress === undefined || inProgress === null
                ? gameInterval.contains(now)
                : inProgress,
        onError: onError || noop,
        genderDoesNotMatch:
            getProfile(state) &&
            !gameData.players_gender.includes(getProfile(state).gender),
        userAge,
        paymentMethod: listItem
            ? getGamePaymentMethodItem(state, id)
            : getGamePaymentMethod(state, id),
        isPaySuccess: listItem
            ? getIsPaySuccessItem(state, id)
            : getIsPaySuccess(state, id),
        payStatus: listItem
            ? getIsPayStatusItem(state, id)
            : getIsPayStatus(state, id),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateGameData: (id, gameData) => {
            dispatch(updateGameDataForList(id, gameData));
            dispatch(updateGameDataForPage(id, gameData));
        },
        trackPlayerJoin: (userId, gameId) =>
            dispatch(trackPlayerJoin(userId, gameId)),
        trackPlayerLeft: (userId, gameId) =>
            dispatch(trackPlayerLeft(userId, gameId)),
        dropCard: (id) => dispatch(dropCard(id)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Component);
